import { template as template_27893fcfe6bd49c0a79118f49fdc75e7 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/file-extract';
const { stringify } = JSON;
export default RouteTemplate(template_27893fcfe6bd49c0a79118f49fdc75e7(`
  <div
    data-prerender-file-extract
    data-prerender-file-extract-id={{@model.id}}
    data-prerender-file-extract-nonce={{@model.nonce}}
    data-prerender-file-extract-status={{@model.status}}
  >
    <pre>{{stringify @model null 2}}</pre>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
